import {
  FETCH_USER_TYPES,
  FETCH_USER_TYPES_SUCCESS,
  FETCH_USER_TYPES_FAILED,
  EDIT_USER_TYPE,
} from "../store/types";
import { language } from "config";

export const fetchUserTypes = () => (dispatch) => (firebase) => {
  const { userTypesRef } = firebase;

  dispatch({
    type: FETCH_USER_TYPES,
    payload: null,
  });
  userTypesRef.on("value", (snapshot) => {
    if (snapshot.val()) {
      let data = snapshot.val();
      const arr = Object.keys(data).map((i) => {
        data[i] = i;
        return data[i];
      });
      dispatch({
        type: FETCH_USER_TYPES_SUCCESS,
        payload: arr,
      });
    } else {
      dispatch({
        type: FETCH_USER_TYPES_FAILED,
        payload: language.no_specialitys,
      });
    }
  });
};

export const editUserType =
  (usertypes, method) => (dispatch) => (firebase) => {
    const { userTypesRef, userTypesEditRef } = firebase;
    dispatch({
      type: EDIT_USER_TYPE,
      payload: { method, usertypes },
    });
    if (method === "Add") {
      userTypesRef.push(usertypes);
    } else if (method === "Delete") {
      userTypesEditRef(usertypes.id).remove();
    } else {
      userTypesEditRef(usertypes.id).set(usertypes);
    }
  };
